import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';

import Swal from 'sweetalert2'; // Import SweetAlert2
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2
 import { useNavigate, Link } from 'react-router-dom';
import toast from "react-hot-toast";
import LoadingTable from '../../components/LoadingTable';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import getDecryptData from '../../../helpers/getDecryptData';
 import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components


const AdminAllPaymentsOrderInvoice = () => {


 

    const [Dateinputs, setDateinputs] = useState({
        startDate: null, // Use null or a default Date object
        endDate: null    // Use null or a default Date object
    });

    const handleStartDateChange = (ranges) => {
        setDateinputs((prevState) => ({
            ...prevState,
            startDate: ranges.selection.startDate,
            endDate: ranges.selection.endDate,
        }));
    };




    const [DateFilter, SetDateFilter] = useState(false);
    const [myStatus, setStatus] = useState(3);
    const [driverPaymentFilter, setDriverPaymentFilter] = useState(3);
    const [User, setUser] = useState('');
    const [AllUsers, setAllUser] = useState([]);

         const [totalAMT, setTotalAMT] = useState({});

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setlimit] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [commission, setcommission] = useState(0);


    const fetchData = async () => {
        if(Dateinputs.startDate !== null && Dateinputs.endDate ){
 try {

            setLoading(true);

            const startDate = Dateinputs.startDate ? Dateinputs.startDate.toISOString() : '';
            const endDate = Dateinputs.endDate ? Dateinputs.endDate.toISOString() : '';

            const response = await axiosInstance.get(`/admin/all-order-invoice?page=${currentPage}&limit=${limit}&search=${searchTerm}&startDate=${startDate}&endDate=${endDate}&status=${myStatus}&userId=${User}&empstatus=${driverPaymentFilter}`);

            setCurrentPage(response.data.currentPage);
            setTotalPages(response.data.totalPages);
            const data =  response.data.data;
            setTotalAMT(response.data.extraData ?? {});
          setTotalAMT(response.data.extraData ?? {});

            console.log(data)
            setData(data);
            setcommission(response.data.commission ?? 0);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
            setData([]);
            setlimit(10);
            setTotalPages(1);
            setCurrentPage(1);
              setTotalAMT({});
        } finally {
            setLoading(false);
            SetDateFilter(false);
        }

        }
       else{
         setLoading(false);
         setData([]);
         setcommission(0);
         setTotalAMT(0);
}
    };

const AllUser = async() => {
          try {
        const response = await axiosInstance.get(`/all-user`);
            const users =  response.data.users;
            setAllUser(users ?? [])
            console.log('usersusersusers',AllUsers)
        }
        catch (error) {
            console.error('Error fetching data:', error);
    }
}
    


    useEffect(() => {
             fetchData(currentPage);
     }, [Dateinputs]);

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage, limit,myStatus,User,driverPaymentFilter]);

    useEffect(() => {
AllUser();
 }, []);
    

    const handleDateFilter = () => {
        SetDateFilter(true);
        setCurrentPage(1)
    }

    const handleClearFilter = () => {
        SetDateFilter(true);
        setCurrentPage(1);
        setDateinputs((prevState) => ({
            ...prevState,
            startDate: null,
            endDate: null,
        }));
    }

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

 


    const handleStatusChange = (StatusId) => async (event) => {
        const newStatus = event.target.value;
        setLoading(true);

        try {
            await axiosInstance.put(`/admin/update-user/${StatusId}`, { status: newStatus });
            setLoading(false);
            fetchData(currentPage);
            toast.success("Status Updated success!");
        } catch (error) {
            console.error('Error updating rating status:', error);
            setLoading(false);
        }
    };

    const driverPaymentStatus = {
        0: { label: "Unpaid", className: "bg-warning text-dark" },
        1: { label: "Paid", className: "bg-success text-white" },
        2: { label: "Cancel", className: "bg-danger text-white" },
    };

    const handleDriverPaymentStatusChange = (orderId, currentStatus) => async (event) => {
        const newStatus = Number(event.target.value);

        const { value: formValues } = await MySwal.fire({
            title: "Technician Payment Status",
            html: `
                <textarea id="driver-payment-comment" class="swal2-textarea" placeholder="Comment is required"></textarea>
                <input id="driver-payment-transaction" class="swal2-input" placeholder="Transaction ID (optional)" />
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Update",
            preConfirm: () => {
                const comment = document.getElementById("driver-payment-comment").value.trim();
                const transactionId = document.getElementById("driver-payment-transaction").value.trim();

                if (!comment) {
                    Swal.showValidationMessage("Comment is required");
                    return false;
                }

                return { comment, transactionId };
            },
        });

        if (!formValues) {
            event.target.value = currentStatus;
            return;
        }

        setLoading(true);
        try {
            await axiosInstance.put(`/admin/update-order-empstatus/${orderId}`, {
                status: newStatus,
                comment: formValues.comment,
                transactionId: formValues.transactionId,
            });
            toast.success("Technician payment status updated!");
            fetchData(currentPage);
        } catch (error) {
            console.error("Error updating driver payment status:", error);
            toast.error(error?.response?.data?.message || "Failed to update driver payment status.");
            event.target.value = currentStatus;
        } finally {
            setLoading(false);
        }
    };



    const inputRef = React.createRef();

    const handleSearchInputChange = (e) => {
        setCurrentPage(1);
        setTotalPages(1)
        setSearchTerm(e.target.value);


    };

    const handleSearch = () => {
        fetchData(currentPage);

    };


    const [WalletLoading, setWalletLoading] = useState(true);



    let initialWalletData = {
        _id: null,
        TotalAmount: 0,
        WalletType: '',
        Amount: null,
        Comment: '',
    };

    const [WalletInputs, setWalletInputs] = useState(initialWalletData);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'Amount' && parseFloat(value) < 0) {
            // You can handle the error, show a message, or prevent further action here
            // For now, let's reset the value to 0
            // You might want to handle this differently based on your UI/UX requirements
            toast.error('Negative numbers not allowed for Amount');
            return;
        } else {
            setWalletInputs((prevData) => ({ ...prevData, [name]: type === 'checkbox' ? checked : value }));

        }

    };



    function formatDate(dateString) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString("en-US", options);
    }

    const paymentLabel = (payment) => {
        if (payment === 0) return "Pending";
        if (payment === 1) return "Success";
        if (payment === 2) return "Failed";
        return "";
    };

    const escapeExcelValue = (value) => String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

    const buildInvoiceQuery = (extraParams = "") => {
        const startDate = Dateinputs.startDate ? Dateinputs.startDate.toISOString() : "";
        const endDate = Dateinputs.endDate ? Dateinputs.endDate.toISOString() : "";

        return `/admin/all-order-invoice?page=${currentPage}&limit=${limit}&search=${searchTerm}&startDate=${startDate}&endDate=${endDate}&status=${myStatus}&userId=${User}&empstatus=${driverPaymentFilter}${extraParams}`;
    };



    const ExportData = async () => {
        if (!Dateinputs.startDate || !Dateinputs.endDate) {
            toast.error("Please select date range before export.");
            return;
        }

        try {
            const response = await toast.promise(
                axiosInstance.get(buildInvoiceQuery("&export=1")),
                {
                    loading: "Exporting order invoices...",
                    success: "Order invoices exported!",
                    error: "Failed to export order invoices.",
                }
            );

            const rows = response.data.data || [];

            if (rows.length === 0) {
                toast.error("No data found for export.");
                return;
            }

            const tableRows = rows.map((row) => {
                const totalWithGST = Number(row.totalAmount || 0);
                const amountCom = Math.round((totalWithGST * commission) / 100);
                const amountwithoutGSt = Math.round((amountCom * 18) / 100);
                const HelperEarning = totalWithGST - (amountCom + amountwithoutGSt);
                const empStatus = driverPaymentStatus[row.empstatus?.status ?? 0]?.label || "Unpaid";

                return `
                    <tr>
                        <td>${escapeExcelValue(row.orderId)}</td>
                        <td>${escapeExcelValue(row.razorpay_order_id)}</td>
                        <td>${escapeExcelValue(row.createdAt ? formatDate(row.createdAt) : "")}</td>
                        <td>${escapeExcelValue(row.agentId?.username)}</td>
                        <td>${escapeExcelValue(row.agentId?.phone)}</td>
                        <td>${escapeExcelValue(totalWithGST)}</td>
                        <td>${escapeExcelValue(HelperEarning)}</td>
                        <td>${escapeExcelValue(amountCom)}</td>
                        <td>${escapeExcelValue(amountwithoutGSt)}</td>
                        <td>${escapeExcelValue(row.paid ?? 0)}</td>
                        <td>${escapeExcelValue(paymentLabel(row.payment))}</td>
                        <td>${escapeExcelValue(empStatus)}</td>
                        <td>${escapeExcelValue(row.empstatus?.transactionId)}</td>
                        <td>${escapeExcelValue(row.empstatus?.comment)}</td>
                    </tr>
                `;
            }).join("");

            const excelHtml = `
                <html>
                    <head>
                        <meta charset="UTF-8" />
                    </head>
                    <body>
                        <table border="1">
                            <thead>
                                <tr>
                                    <th>Order Id</th>
                                    <th>Razorpay Order ID</th>
                                    <th>Date</th>
                                    <th>Vendor Name</th>
                                    <th>Vendor Phone</th>
                                    <th>Total Amount</th>
                                    <th>Technician Earning</th>
                                    <th>IT Service Fee</th>
                                    <th>GST</th>
                                    <th>Technician Payment</th>
                                    <th>Payment</th>
                                    <th>Technician Payment</th>
                                    <th>Transaction ID</th>
                                    <th>Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${tableRows}
                            </tbody>
                        </table>
                    </body>
                </html>
            `;

            const url = window.URL.createObjectURL(new Blob([excelHtml], { type: "application/vnd.ms-excel;charset=utf-8;" }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'order-invoices.xls');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting data:', error);
            toast.error('Error exporting data:', error);
        }

    };

      const downloadInvoice = async (id) => {
         try {
            const response = 
                await toast.promise(
                    axiosInstance.post(
                        `/download-invoice-order`, { invoiceId : id},
                        { responseType: 'blob' }
                    ),
                    {
                        loading: 'Invoice Downloading...',
                        success: 'Invoice Downloaded!',
                        error: 'Failed to Download Invoice.'
                    }
                );

            // await axiosInstance.get(`/admin/export/alltrans/`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'invoice.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
            toast.error('Error exporting data:', error);
        }

    };
    

    
    
    const downloadVendorInvoice = async (id) => {
         try {
            const response = 
                await toast.promise(
                    axiosInstance.post(
                        `/download-invoice-order-vendor`, { invoiceId : id},
                        { responseType: 'blob' }
                    ),
                    {
                        loading: 'Vendor Invoice Downloading...',
                        success: 'Vendor Invoice Downloaded!',
                        error: 'Failed to Download Vendor Invoice.'
                    }
                );

            // await axiosInstance.get(`/admin/export/alltrans/`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'invoice.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error('Error exporting data:', error);
            toast.error('Error exporting data:', error);
        }

    };



    

    return (
        <>

              <Sidebar />
              <main class="content">
                <Navbar />
        
                <div className="py-4">
                 
                <div className="dashboard-content bg-white px-4 py-3 " style={{ maxWidth: "100vw", }} >



                    <div className="table-responsive py-4" style={{ overflow: "visible" }} >

                        {loading ? (
                            <LoadingTable />
                        ) : (
                            <>




                                <div className="dropdown">


                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm dropdown-toggle mb-3"
                                        data-bs-toggle="dropdown"
                                        data-bs-auto-close="outside"
                                        aria-expanded="false"
                                    >
                                        <i className="ri-filter-2-fill me-2"></i>   Filter
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm mb-3 ms-2"
                                        onClick={ExportData}
                                    >
                                        <i className="ri-file-excel-2-line me-2"></i> Export Excel
                                    </button>

   {(Dateinputs.startDate && Dateinputs.endDate) &&
                                        <span className='d-inline-block  p-2  border-right'>
                                            <label className='d-inline-block fw-bold'> Start Date
                                            </label> <br />
                                            <div className="d-inline-block badge rounded-pill bg-dark px-2 py-2 ps-1" type="button" onClick={handleClearFilter}>
                                                <i className="ri-close-line bg-white p-1 rounded-xl me-1 text-dark rounded-circle"></i>
                                                {formatDate(Dateinputs.startDate.toISOString())}
                                            </div>
                                        </span>}

                                    {(Dateinputs.startDate && Dateinputs.endDate) &&
                                        <span className='d-inline-block  p-2'>
                                            <label className='d-inline-block fw-bold'>End Date
                                            </label> <br />
                                            <div className="d-inline-block badge rounded-pill bg-dark px-2 py-2 ps-1" type="button" onClick={handleClearFilter}>
                                                <i className="ri-close-line bg-white p-1 rounded-xl me-1 text-dark rounded-circle"></i>
                                                {formatDate(Dateinputs.endDate.toISOString())}
                                            </div>
                                        </span>}

                                    <div className="dropdown-menu border rounded-md p-4  table-flow overflow-auto " style={{ zIndex: "99" }} >



                                        <b className='d-block fw-bold'> Filters By Date </b>

  <DateRangePicker className=" my-3 w-auto "
                                            onChange={handleStartDateChange}
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={true}
                                            ranges={[
                                                {
                                                    startDate: Dateinputs.startDate,
                                                    endDate: Dateinputs.endDate,
                                                    key: 'selection',
                                                },
                                            ]}
                                        /> 

                                        <div className='d-flex text-right justify-content-between align-items-center'>


                                            {Dateinputs.startDate && Dateinputs.endDate && (<>

                                                <button
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseExample"
                                                    aria-expanded="true"
                                                    aria-controls="collapseExample" onClick={handleClearFilter}
                                                    className=' btn btn-sm btn-danger text-white me-4'>
                                                    <i className="ri-delete-bin-5-fill me-2"></i> Clear
                                                </button>
                                                <button
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseExample"
                                                    aria-expanded="true"
                                                    aria-controls="collapseExample" onClick={handleDateFilter}
                                                    className='ms-auto btn btn-sm btn-secondary bg-dark text-white '>
                                                    <i className="ri-filter-3-fill me-2"></i> Apply
                                                </button>
                                            </>)}
                                        </div>

                                    </div>

                                    <div className='bg-fix' />

                                </div>


<div className='row mb-4'>
    <div className='col-12'>
        <div className=' small bg-success d-inline-block p-2 text-white rounded mb-2'>
Top Outstanding : <b className='text-white'>
   {totalAMT.TotalOutstand ?? 0} </b>
</div>

    </div>
        <div className='col-md-2 small'>
  Total Amount : <b className='text-dark'> {totalAMT.totalAmountSum ?? 0 } </b>
    </div>

    <div className='col-md-2 small'>
   Technician Earning : <b className='text-dark'> {totalAMT.HelperEarning ?? 0} </b>
    </div>

        <div className='col-md-2 small'> IT Service Fees : <b className='text-dark' > {totalAMT.TotalITFees ?? 0} </b>
    </div>

  <div className='col-md-2 small'>
 GST : <b className='text-dark'>
   {totalAMT.TotalGst ?? 0} </b>
</div>
 



</div>
 


                                <div className="datatable-top row justify-content-between align-items-center">
                                    <div className="datatable-dropdown col-md-3 ">



                                        <label className='d-flex gap-2 align-items-center '>
                                            <select className="form-control w-auto pe-4" value={limit} onChange={(e) => {
                                                setlimit(parseInt(e.target.value, 10));
                                                setCurrentPage(1); // Reset current page to 1 when the limit changes
                                            }} >
                                                <option value={5}>5</option>
                                                <option value={10} >
                                                    10
                                                </option>
                                                <option value={15}>15</option>
                                                <option value={20}>20</option>
                                                <option value={25}>25</option>
                                                <option value={100}>100</option>
                                                <option value={500}>500</option>
                                                <option value={1000}>1000</option>

                                            </select>{" "}

                                            entries per page
                                        </label>




                                    </div>

                                    <label className='d-flex gap-2 align-items-center col-md-2 '>
                                         Status
                                   
                                       <select className="form-control w-auto pe-4" 
                                       value={myStatus} onChange={(e) => {
                                                setStatus((e.target.value));
                                                setCurrentPage(1); // Reset current page to 1 when the limit changes
                                            }} >
                                                <option value={3}>All</option>
                                                <option value={0} >
                                                Pending
                                                </option>
                                                <option value={1}>Success</option>
                                                <option value={2}>Failed</option>
 
                                            </select>{" "}
 
                                        </label>

                                    <label className='d-flex gap-2 align-items-center col-md-2 '>
                                         Technician Payment

                                       <select className="form-control w-auto pe-4"
                                       value={driverPaymentFilter} onChange={(e) => {
                                                setDriverPaymentFilter((e.target.value));
                                                setCurrentPage(1);
                                            }} >
                                                <option value={3}>All</option>
                                                <option value={0}>Unpaid</option>
                                                <option value={1}>Paid</option>
                                                <option value={2}>Cancel</option>

                                            </select>{" "}

                                        </label>

                                                 <label className='d-flex gap-2 align-items-center col-md-2 '>
                                         User
                                   
                            <select className="form-control w-100 pe-4" 
                                       value={User} onChange={(e) => {
                                                setUser((e.target.value));
                                                setCurrentPage(1); // Reset current page to 1 when the limit changes
                                            }} >
                          <option value={''}>All User</option>
                                            
                           {AllUsers.map((user, index) => (
                           <option value={user._id} key={index}>
                           {user.username}
                           </option>
                           ))}
                               </select> 
 
                                        </label>


                                    <header className="header bg-transparent style-2 col-md-3">
                                        <div className="header-content">
                                            <div className="search-area d-flex">

                                                <div className=" input-rounded w-100">
                                                    <input type="search" className="form-control" placeholder="Search..." value={searchTerm}
                                                        onChange={handleSearchInputChange} />
                                                </div>

                                                <button type={'button'} onClick={handleSearch} className=" rounded-circle ms-2 back-btn border-0 d-flex justify-content-center align-items-center">
                                                    <i className="ri-search-line h4 m-0"></i>
                                                </button>


                                            </div>
                                        </div>
                                    </header>



                                </div>


                                <div className='overflow-auto table-flow'>

                                    <table className="table table-flush">
                                        <thead>
                                            <tr>
                                                <th>Transaction No.</th>
                                                <th> Date</th>
                                                <th>Vendor Details	</th>
   
                                                <th> Total Amount</th>
                                                <th> Payment</th>
                                                <th> Technician Payment</th>
                                                <th> Action</th>

                                            </tr>
                                        </thead>
                                        <tbody  style={{height:'50vh'}}>
                                        
                                            {data.map((row, index) => {
                                                const user = row.userId || {}; // Ensure userId is defined
                                                const gstRate = 0.18;
                                                const fcommission = commission;
                                                const totalWithGST = row.totalAmount ;
                                                const amountCom = Math.round(( totalWithGST * fcommission) / 100);
                                              const amountwithoutGSt = Math.round(( amountCom * 18) / 100);
                                                const amountWithGst = amountCom + amountwithoutGSt ;

                                        const HelperEarning =  totalWithGST - amountWithGst;
 
  
                                                return (
                                                    <tr key={index}>
                                                        <td className='small'>
                                                            <p className='small'>
                                                                <b className="fw-bold">Order Id: </b>{row.orderId}
                                                                <br />
                                                                <b className="fw-bold">Razorpay Order ID: </b>{row.razorpay_order_id}
                                                            </p>
                                                        </td>
                                                        <td className='small'>{formatDate(row.createdAt)}</td>
                                                        <td className='small' >Name : {row.agentId?.username} <br/>
                                                        Phone : {row.agentId?.phone} </td>
                                                          <td className='small' > Total Amount: {totalWithGST} <br/> 
                                                           Helper Earning : {HelperEarning} <br/> 
                                                            IT Service Fee: {amountCom} <br/> 
                                                             GST : {amountwithoutGSt} <br/> 
                                                               Pending Payment : {row.paid ?? 0} <br/> 
                                                          </td>
                                                        <td className='small' >
                                                        {row.payment === 0 && <span className='badge bg-warning'> Pending </span>}
                                                         {row.payment === 1 &&  <span className='badge bg-success'> Success </span> } 
                                                        {row.payment === 2 &&  <span className='badge bg-danger'> Failed </span> }
                                                        
                                                        </td>

                                                        <td className='small' >
                                                            <span className={`badge ${driverPaymentStatus[row.empstatus?.status ?? 0]?.className}`}>
                                                                {driverPaymentStatus[row.empstatus?.status ?? 0]?.label}
                                                            </span>

                                                            <select
                                                                className="form-control form-control-sm mt-2"
                                                                value={row.empstatus?.status ?? 0}
                                                                onChange={handleDriverPaymentStatusChange(row._id, row.empstatus?.status ?? 0)}
                                                            >
                                                                <option value={0}>Unpaid</option>
                                                                <option value={1}>Paid</option>
                                                                <option value={2}>Cancel</option>
                                                            </select>

                                                            {row.empstatus?.transactionId && (
                                                                <div className="mt-2">
                                                                    <b>Transaction ID:</b> {row.empstatus.transactionId}
                                                                </div>
                                                            )}

                                                            {row.empstatus?.comment && (
                                                                <div className="mt-1">
                                                                    <b>Comment:</b> {row.empstatus.comment}
                                                                </div>
                                                            )}
                                                        </td>

                                                        <td>
                                                        <button
                                className="small bg-dark rounded px-2 py-1 text-white d-block mb-2 border-0"
                                onClick={() => downloadVendorInvoice(row._id)}
                                >
                                Invoice
                              </button>

            <button
                                className="small bg-dark rounded px-2 py-1 text-white d-block mb-2 border-0"
                                onClick={() => downloadInvoice(row._id)}
                                >
                              User  Invoice
                              </button>

                                {/* <button
                                className="small bg-dark rounded px-2 py-1 text-white d-block mb-2 border-0"
                                onClick={() => downloadVendorInvoice(row._id)}
                                >
                                Vendor Invoice
                              </button> */}

                              

                                                        </td>
                                                    </tr>
                                                );
                                            })}

{data.length === 0 && <tr>
  <td
    colSpan="12"
    style={{
      textAlign: "center",
      height: "50vh",
      verticalAlign: "middle"
    }}
  >
    No Data found
  </td>
</tr>
}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="datatable-bottom">
                                    <div className="datatable-info">  </div>
                                    <nav className="datatable-pagination ms-auto">
                                        <ul className="pagination justify-content-end">

                                            <li className={`page-item rounded-md ${currentPage === 1 ? 'datatable-hidden' : 'active'} bg-transparent  `}>
                                                <button data-page="1" className="page-link " onClick={handlePreviousPage} disabled={loading || currentPage === 1}
                                                    aria-label="Page 1">‹</button>
                                            </li>
                                            <li>
                                                <div className="datatable-info py-1 px-3">Showing  Page{' '}
                                                    <strong>
                                                        Showing Page  {currentPage} of {totalPages}

                                                    </strong>{' '} </div>
                                            </li>
                                            <li className={`page-item rounded-md ${currentPage === totalPages ? 'datatable-hidden' : 'active'}`}>
                                                <button data-page="2" className="page-link" aria-label="Page 2" onClick={handleNextPage} disabled={loading || currentPage === totalPages}
                                                >  {loading ? 'Loading...' : '›'} </button>
                                            </li>
                                        </ul></nav>
                                </div>



                            </>
                        )}

                    </div>




                </div>
  </div>
  </main>
  
        </>
    )
}

export default AdminAllPaymentsOrderInvoice
